/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-04-29 16:33:04
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\axios\http.js
 * @
 */
import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import { getToken, removeToken, removeMenu, removePermission } from '@/cookie/cookie'
import i18n from '../common/lang/index'
import store from '../store/index'
// 创建axios实例
// Axios配置文件，所有接口都存放在api文件夹里面，每个页面对应一个接口文件
const service = axios.create({
    // baseURL: 'http://10.10.11.13:3000', // api 的 base_url
    // 请求超时时间,
    // baseURL: 'http://192.168.10.136:3000',
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: false
})
// 
service.interceptors.request.use(
    config => {
        if (getToken()) {
            config.headers.token = getToken()
        }
        // axios的CancelToken实例对象中的cancel函数可以取消请求
        config.cancelToken = new axios.CancelToken(function(cancel){
          // 存储待中断的请求
          store.dispatch('pushToken', {cancelToken: cancel})
        })
        return config
    },
    error => {
        Promise.reject(error)
    }
)
service.interceptors.response.use(function(response) {  
    //登录状态过期提示，后端默认30分钟未操作登录状态过期，只要返回code为2就是过期，清空所有coookie与获取到的id
    if (response.data.code === 2) {
        removeToken()
        removeMenu()
        removePermission()
        window.localStorage.clear()
        router.push('/login')
            //删除所有保存数据
    }
    if (response.data.code === 5) {
        Message({
            message: '权限不足，无权操作',
            type: 'warning'
        });
    }
    if (response.data.code === 20) {
        //删除所有保存数据
        removeToken()
        removeMenu()
        removePermission()
        window.localStorage.clear()
        router.push('/login')
    }
    return response;
}, function(error) {
  if(axios.isCancel(error)){
    // 为了终结promise链 就是实际请求，不会走到.catch这一步，这样就不会出发错误提示之类的了
    return new Promise(() => {}) 
  }else{
    // 对响应错误操作
    return Promise.reject(error);
  }
    
});
export default service
